export const config = {
	kratosURL: "/.ory/kratos/public",
	tierivPortalUrl: import.meta.env.VITE_TIER_IV_PORTAL_URL ?? "/",
};
